module.exports = __webpack_public_path__ + "media/video1_2.6e3016da.mp4";